import { combineReducers } from '@reduxjs/toolkit';

import { planAllVersionsSlice } from './planAllVersionsSlice';
import { planEngineeringSlice } from './planEngineeringSlice';
import { planPlacementSlice } from './planPlacementSlice';

export const plan = combineReducers({
  planAllVersions: planAllVersionsSlice.reducer,
  planEngineering: planEngineeringSlice.reducer,
  planPlacement: planPlacementSlice.reducer,
});
